<template>
  <div v-if="modal.backdrop">
    <div
      class="modal fade"
      :class="modal.modal ? 'show' : ''"
      style="display: block"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div
        :class="'modal-dialog modal-dialog-centered ' + className"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ title }}</h5>
            <button
              type="button"
              class="close"
              @click="action"
              v-html="loading ? spin() : ic('close')"
            />
          </div>
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helper from "@/assets/js/helper.js";
import { mapState } from "vuex";

export default {
  name: "Modal",
  mixins: [helper],
  props: {
    className: { default: "modal-md" },
    action: {
      type: Function,
    },
    title: { default: "Filter" },
    modal: {
      default: {
        backdrop: false,
        modal: false,
      },
    },
  },
  computed: {
    ...mapState(["loading"]),
  },
  data() {
    return {};
  },
  methods: {
    _close() {
      this.modal.backdrop = false;
      this.modal.modal = false;
    },
  },
  mounted() {},
  watch: {},
};
</script>
